<ng-container *ngIf="useMatFields">
	
	<mat-form-field appearance="fill">
		<mat-label>{{ 'PROPERTY' | translate }}</mat-label>
		<mat-select [(ngModel)]="filter.field" (ngModelChange)="filterFieldChanged($event)" [options]="filterConfigOptions" name="filterSort-property">
			<mat-option *ngFor="let option of filterConfigOptions" [value]="option.value">{{ option.label }}</mat-option>
		</mat-select>
	</mat-form-field>

	<!-- Operators -->
	<mat-form-field appearance="fill" class="">
		<mat-label>{{ 'OPERATOR' | translate }}</mat-label>
		<mat-select class="contains" [(ngModel)]="filter.operator" (ngModelChange)="operatorChanged($event)">
			<ng-container *ngIf="operatorType === 'contains'">
				<mat-option value="contains">{{ 'CONTAINS' | translate | lowercase }}</mat-option>
				<mat-option value="doesNotContain">{{ 'DOES_NOT_CONTAIN' | translate | lowercase }}</mat-option>
				<mat-option value="is">{{ 'IS' | translate | lowercase }}</mat-option>
				<mat-option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</mat-option>
				<mat-option value="isEmpty">{{ 'IS_EMPTY' | translate | lowercase }}</mat-option>
				<mat-option value="isNotEmpty">{{ 'IS_NOT_EMPTY' | translate | lowercase }}</mat-option>
			</ng-container>

			<ng-container *ngIf="operatorType === 'containsAny'">
				<mat-option value="containsAnyOf">{{ 'CONTAINS_ANY_OF' | translate | lowercase }}</mat-option>
				<mat-option value="containsAllOf">{{ 'CONTAINS_ALL_OF' | translate | lowercase }}</mat-option>
				<mat-option value="doesNotContainAnyOf">{{ 'DOES_NOT_CONTAIN_ANY_OF' | translate | lowercase }}</mat-option>
			</ng-container>

			<ng-container *ngIf="operatorType === 'is'">
				<mat-option value="is">{{ 'IS' | translate | lowercase }}</mat-option>
				<mat-option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</mat-option>
			</ng-container>

			<ng-container *ngIf="operatorType === 'isDate'">
				<mat-option value="isBefore">{{ 'BEFORE' | translate | lowercase }}</mat-option>
				<mat-option value="isAfter">{{ 'AFTER' | translate | lowercase }}</mat-option>
				<mat-option value="isInTheLast">{{ 'IN_THE_LAST' | translate | lowercase }}</mat-option>
				<mat-option value="isNotInTheLast">{{ 'NOT_IN_THE_LAST' | translate | lowercase }}</mat-option>
			</ng-container>

			<ng-container *ngIf="operatorType === 'isNumber'">
				<mat-option value="is">{{ 'IS' | translate | lowercase }}</mat-option>
				<mat-option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</mat-option>
				<mat-option value="isSmallerThan">{{ 'IS_SMALLER_THAN' | translate | lowercase }}</mat-option>
				<mat-option value="isGreaterThan">{{ 'IS_GREATER_THAN' | translate | lowercase }}</mat-option>
			</ng-container>

			<ng-container *ngIf="operatorType === 'boolean'">
				<mat-option value="true">{{ 'IS_YES' | translate | lowercase }}</mat-option>
				<mat-option value="false">{{ 'IS_NO' | translate | lowercase }}</mat-option>
			</ng-container>
		</mat-select>
	</mat-form-field>

	<!-- Values -->
	<div class="filter-value-wrapper" [class.with-action-button]="allowDatasource">
		<mat-form-field appearance="fill"
			*ngIf="(fieldInterfaceType === 'textarea' || fieldInterfaceType === 'text' || fieldInterfaceType === 'number' || fieldInterfaceType === 'facetquery') && (filter.operator !== 'isEmpty' && filter.operator !== 'isNotEmpty')"
			class="text-input full-width"
		>
			<mat-label>
				{{ 'VALUE' | translate }}
			</mat-label>
			<input matInput type="text" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)" />
		</mat-form-field>

		<mat-form-field
			[hidden]="fieldInterfaceType !== 'date' || (filter.operator !== 'isBefore' && filter.operator !== 'isAfter')"
			appearance="fill" class="full-width" (click)="calendarOpen = !calendarOpen" (clickOutside)="calendarOpen = false;"
			[clickOutsideExcludeQueries]="['.date-input-overlay-panel']">
			<mat-label>{{ 'VALUE' | translate }}</mat-label>
			<input matInput [matDatepicker]="picker" (ngModelChange)="valueChanged($event)" [(ngModel)]="filter.value">
			<button type="button" class="date-icon" mat-icon-button matSuffix cdkOverlayOrigin #triggerDateInput="cdkOverlayOrigin">
				<i class="far fa-calendar fa-lg"></i>
			</button>
			<mat-datepicker #picker></mat-datepicker>
		</mat-form-field>
		
		<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="triggerDateInput" [cdkConnectedOverlayOpen]="calendarOpen">
			<div class="panel date-input-overlay-panel">
				<mat-calendar [selected]="filter.value" [startAt]="filter.value" (selectedChange)="calendarValueChanged($event)"></mat-calendar>
				<bb-button theme="light-v2" class="close-button" (click)="calendarOpen = false">{{ 'CLOSE' | translate }}
				</bb-button>
			</div>
		</ng-template>

		<div *ngIf="fieldInterfaceType === 'date' && (filter.operator === 'isInTheLast' || filter.operator === 'isNotInTheLast')" class="in-the-last">
			<mat-form-field appearance="fill">
				<mat-label>
					{{ 'NUMBER' | translate }}
				</mat-label>
				<input matInput type="number" [(ngModel)]="inTheLastNumber" (ngModelChange)="valueChanged($event, true)" />
			</mat-form-field>
			<mat-form-field appearance="fill">
				<mat-label>
					{{ 'UNIT' | translate }}
				</mat-label>
				<mat-select [(ngModel)]="inTheLastPeriod" (ngModelChange)="valueChanged($event, true)">
					<mat-option value="hours">{{ 'HOUR_OR_HOURS' | translate | lowercase }}</mat-option>
					<mat-option value="days">{{ 'DAY_OR_DAYS' | translate | lowercase }}</mat-option>
					<mat-option value="months">{{ 'MONTH_OR_MONTHS' | translate | lowercase }}</mat-option>
					<mat-option value="years">{{ 'YEAR_OR_YEARS' | translate | lowercase }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<mat-select *ngIf="options && (fieldInterfaceType === 'select' || fieldInterfaceType === 'singleSelect' || fieldInterfaceType === 'singleClipSelect')" name="mediaTypes" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)">
			<mat-option *ngFor="let option of options" [value]="option.value">
				{{ option.label }}
			</mat-option>
		</mat-select>

		<mat-form-field appearance="fill" class="full-width" *ngIf="(!options && (fieldInterfaceType === 'select' || fieldInterfaceType === 'singleSelect' || fieldInterfaceType === 'singleClipSelect')) || fieldInterfaceType === 'multiSelect' || fieldInterfaceType === 'customMultiSelect'">
			<mat-label>
				{{ 'VALUE' | translate }}
			</mat-label>
			<bb-entity-selector theme="light-v2" class="width" [inMatFormField]="true" *ngIf="!options && (fieldInterfaceType === 'select' || fieldInterfaceType === 'singleSelect' || fieldInterfaceType === 'singleClipSelect')" [(ngModel)]="filter.value"
				(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [facet]="filter.field" name="mediaTypes" 
				[extendable]="true" [filterSet]="filterSet">
			</bb-entity-selector>

			<bb-entity-selector theme="light-v2" class="entity-selector width" [inMatFormField]="true" *ngIf="fieldInterfaceType === 'multiSelect'" [(ngModel)]="filter.value"
				(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [multi]="true" [extendable]="true" [facet]="filter.field"
				[name]="filter.field" [filterSet]="filterSet">
			</bb-entity-selector>

			<bb-entity-selector theme="light-v2" class="entity-selector width" [inMatFormField]="true" *ngIf="fieldInterfaceType === 'customMultiSelect'" [(ngModel)]="filter.value"
				(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [multi]="true" [extendable]="true" [facet]="filter.field"
				[name]="filter.field" [filterSet]="filterSet">
			</bb-entity-selector>

			<input matInput hidden />
		</mat-form-field>


		<div class="action-button"
			*ngIf="allowDatasource"
			[title]="'USE_DATA_SOURCE' | translate"
			[class.active]="filter.datasource"
			(click)="dataSourceService.onDataSourceClicked(filter, dataSourceTemplate)"
		>
			<i class="fa fa-plug"></i>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!useMatFields">
	<bb-select [(ngModel)]="filter.field" (ngModelChange)="filterFieldChanged($event)" [options]="filterConfigOptions"
		name="filterSort-property">
	</bb-select>

	<!-- Operators -->
	<bb-select class="contains" *ngIf="operatorType === 'contains'" [(ngModel)]="filter.operator"
		(ngModelChange)="operatorChanged($event)">
		<option value="contains">{{ 'CONTAINS' | translate | lowercase }}</option>
		<option value="doesNotContain">{{ 'DOES_NOT_CONTAIN' | translate | lowercase }}</option>
		<option value="is">{{ 'IS' | translate | lowercase }}</option>
		<option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</option>
		<option value="isEmpty">{{ 'IS_EMPTY' | translate | lowercase }}</option>
		<option value="isNotEmpty">{{ 'IS_NOT_EMPTY' | translate | lowercase }}</option>
	</bb-select>

	<bb-select class="containsAny" [(ngModel)]="filter.operator" (ngModelChange)="operatorChanged($event)"
		*ngIf="operatorType === 'containsAny'">
		<option value="containsAnyOf">{{ 'CONTAINS_ANY_OF' | translate | lowercase }}</option>
		<option value="containsAllOf">{{ 'CONTAINS_ALL_OF' | translate | lowercase }}</option>
		<option value="doesNotContainAnyOf">{{ 'DOES_NOT_CONTAIN_ANY_OF' | translate | lowercase }}</option>
	</bb-select>

	<bb-select class="is" [(ngModel)]="filter.operator" (ngModelChange)="operatorChanged($event)"
		*ngIf="operatorType === 'is'">
		<option value="is">{{ 'IS' | translate | lowercase }}</option>
		<option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</option>
	</bb-select>

	<bb-select class="isDate" [(ngModel)]="filter.operator" (ngModelChange)="operatorChanged($event)"
		*ngIf="operatorType === 'isDate'">
		<option value="isBefore">{{ 'BEFORE' | translate | lowercase }}</option>
		<option value="isAfter">{{ 'AFTER' | translate | lowercase }}</option>
		<option value="isInTheLast">{{ 'IN_THE_LAST' | translate | lowercase }}</option>
		<option value="isNotInTheLast">{{ 'NOT_IN_THE_LAST' | translate | lowercase }}</option>
	</bb-select>

	<bb-select class="isNumber" [(ngModel)]="filter.operator" (ngModelChange)="operatorChanged($event)"
		*ngIf="operatorType === 'isNumber'">
		<option value="is">{{ 'IS' | translate | lowercase }}</option>
		<option value="isNot">{{ 'IS_NOT' | translate | lowercase }}</option>
		<option value="isSmallerThan">{{ 'IS_SMALLER_THAN' | translate | lowercase }}</option>
		<option value="isGreaterThan">{{ 'IS_GREATER_THAN' | translate | lowercase }}</option>
	</bb-select>

	<bb-select class="boolean" [(ngModel)]="filter.value" (ngModelChange)="operatorChanged($event)"
		*ngIf="operatorType === 'boolean'">
		<option value="true">{{ 'IS_YES' | translate | lowercase }}</option>
		<option value="false">{{ 'IS_NO' | translate | lowercase }}</option>
	</bb-select>

	<!-- Values -->
	<div class="filter-value-wrapper" [class.with-action-button]="allowDatasource">
			
		<div *ngIf="(fieldInterfaceType === 'textarea' || fieldInterfaceType === 'text') && (filter.operator !== 'isEmpty' && filter.operator !== 'isNotEmpty')"
			class="text-input"><input type="text" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)"/>
		</div>

		<div *ngIf="(fieldInterfaceType === 'number' || fieldInterfaceType === 'facetquery') && (filter.operator !== 'isEmpty' && filter.operator !== 'isNotEmpty')"
			class="text-input"><input type="number" oninput="this.value=this.value.slice(0,this.maxLength)" max="999999999" maxlength="9" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)"/>
		</div>

		<bb-datepicker class="width" *ngIf="fieldInterfaceType === 'date' && (filter.operator === 'isBefore' || filter.operator === 'isAfter')" [initialDate]="today" 
			[initialOpen]="false" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)">
		</bb-datepicker>

		<div *ngIf="fieldInterfaceType === 'date' && (filter.operator === 'isInTheLast' || filter.operator === 'isNotInTheLast')" class="in-the-last">
			<input type="number" [(ngModel)]="inTheLastNumber" (ngModelChange)="valueChanged($event, true)"/>
			<bb-select [(ngModel)]="inTheLastPeriod" (ngModelChange)="valueChanged($event, true)">
				<option value="hours">{{ 'HOUR_OR_HOURS' | translate | lowercase }}</option>
				<option value="days">{{ 'DAY_OR_DAYS' | translate | lowercase }}</option>
				<option value="months">{{ 'MONTH_OR_MONTHS' | translate | lowercase }}</option>
				<option value="years">{{ 'YEAR_OR_YEARS' | translate | lowercase }}</option>
			</bb-select>
		</div>

		<bb-select *ngIf="options && (fieldInterfaceType === 'select' || fieldInterfaceType === 'singleSelect' || fieldInterfaceType === 'singleClipSelect')" name="mediaTypes" [(ngModel)]="filter.value" (ngModelChange)="valueChanged($event)" [options]="options"></bb-select>

		<bb-entity-selector class="width" *ngIf="!options && (fieldInterfaceType === 'select' || fieldInterfaceType === 'singleSelect' || fieldInterfaceType === 'singleClipSelect')" [(ngModel)]="filter.value"
			(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [facet]="filter.field" name="mediaTypes" 
			[extendable]="true" [filterSet]="filterSet">
		</bb-entity-selector>

		<bb-entity-selector class="entity-selector width" *ngIf="fieldInterfaceType === 'multiSelect'" [(ngModel)]="filter.value"
			(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [multi]="true" [extendable]="true" [facet]="filter.field"
			[name]="filter.field" [filterSet]="filterSet">
		</bb-entity-selector>

		<bb-entity-selector class="entity-selector width" *ngIf="fieldInterfaceType === 'customMultiSelect'" [(ngModel)]="filter.value"
			(ngModelChange)="valueChanged($event)" [entityType]="filter.type || 'mediaclip'" [multi]="true" [extendable]="true" [facet]="filter.field"
			[name]="filter.field" [filterSet]="filterSet">
		</bb-entity-selector>

		<div class="action-button"
			*ngIf="allowDatasource"
			[title]="'USE_DATA_SOURCE' | translate"
			[class.active]="filter.datasource"
			(click)="dataSourceService.onDataSourceClicked(filter, dataSourceTemplate)"
		>
			<i class="fa fa-plug"></i>
		</div>
	</div>
</ng-container>

<ng-template #dataSourceTemplate>
	<bb-data-source-picker
		*ngIf="dataSourceService.dataSourceModel !== undefined"
		[model]="dataSourceService.dataSourceModel"
		[disallow]="{WidgetProperty: true}"
		[separateDataSource]="true"
		(ok)="dataSourceService.onDataSourceOk($event, 'datasource'); filterChanged();"
		(remove)="dataSourceService.onDataSourceRemove($event, 'datasource', true); filterChanged();"
		(cancel)="dataSourceService.onDataSourceCancel($event)"
		(closed)="dataSourceService.onDataPickerClosed()"
	></bb-data-source-picker>
</ng-template>
